import {
  ConnectAzureTenant,
  type AzureTenantState,
} from '@/app/(blank-layout-pages)/(authenticated)/onboarding/azure/connectAzureTenant';
import type { Step } from '@/components/wizard/Step';

export const azureConnectTenantFlow: Step<AzureTenantState> = {
  id: 'management_access',
  Component: ConnectAzureTenant,
  nonReturnable: false,
};
